/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect } from 'react'

import { NewsNews } from 'api/models'
import { AbstractListClass } from 'shared/components/AbstractList/AbstractList'
import { useTypedSelector } from 'shared/hooks'
import { getSortBy } from 'shared/utils'
import { getSkip, getUrlParams } from 'shared/utils/getUrlParams'
import { store } from 'store'
import { fetchNews } from 'store/action-creators/news'

import classes from './NewsList.module.scss'
import { NewsListItem } from './NewsListItem/NewsListItem'
import { ItemStatus } from 'models'
import { HistoryLink } from 'shared/components'

type Props = { onMoreBtnClick?: () => void }

// eslint-disable-next-line @typescript-eslint/ban-types
export class List extends AbstractListClass<Props, NewsNews> {
  Store = (): null => {
    const { news, loading, newsTotal } = useTypedSelector(state => state.news)
    useEffect(() => {
      if (!loading) {
        this.setDefault(news, newsTotal)
      }
    }, [loading, news, newsTotal])
    return null
  }

  constructor(props = {}) {
    super(props)
    const params = getUrlParams()
    this.state = {
      items: Array(10).fill(''),
      values: params,
      page: this.getPageNumber(params?.page),
      more: false,
      loading: false,
      totalCount: 0,
      showItemsCount: 10,
    }
    this.getList()
  }

  getList(): void {
    const { showItemsCount: size, page, more } = this.state
    fetchNews(more, {
      ...getSortBy(this.state?.values?.sortBy, undefined, 'date'),
      size,
      offset: getSkip(page, size),
      draftListId: this.state?.values?.draftListId,
    })(store.dispatch)
  }

  renderChildren(): JSX.Element {
    return (
      <div className="row mt-1">
        {this.state.items.map((item, index) => {
          const link = item?.status === ItemStatus.Draft ? './draft/' : './'

          return (
            <div className="col-xs-12 col-sm-6 mb-1" key={index}>
              <HistoryLink to={`${link}${item?.id}`} className={classes.link}>
                <NewsListItem item={item} />
              </HistoryLink>
            </div>
          )
        })}
      </div>
    )
  }

  render(): JSX.Element {
    return (
      <>
        <this.Store />
        {super.render(this.props.onMoreBtnClick)}
      </>
    )
  }
}
